import { Heart } from 'lucide-react';

export const Footer = () => {
    return (
        <footer className="py-8 mt-auto border-t border-border/50 bg-[#FDFCF8]">
            <div className="container-app text-center">
                <p className="text-sm text-muted-foreground flex items-center justify-center gap-1">
                    © 2026 Lumina Faith-Centered Daily Inspiration App 
                    <span className="inline-flex items-center gap-1">
                        — created with <Heart className="w-3 h-3 text-primary fill-primary" /> love
                    </span>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
